import { useContext } from "react";
import DataContext from "../../context/DataContextOld";

const useData = () => useContext(DataContext);

export default useData;
